import { parseDate } from './dateUtils';

const startTime = (row) => {
	const date = parseDate(row?.serviceData?.scheduledDate);
	return date ? date.getTime() : Number.POSITIVE_INFINITY;
};

// Read in date order, not the order given: the caller's list does not catch up with earlier moves
export const getRowMove = (rows, taskId) => {
	if (!Array.isArray(rows)) return null;

	const moved = rows.find((row) => row?.id === taskId);
	if (!moved) return null;

	const others = rows
		.filter((row) => row?.id !== taskId)
		.sort((first, second) => startTime(first) - startTime(second));
	if (others.length === 0) return null;

	const movedStart = startTime(moved);
	const later = others.find((row) => startTime(row) > movedStart);

	return later
		? { id: taskId, target: later.id, mode: "before" }
		: { id: taskId, target: others[others.length - 1].id, mode: "after" };
};
